import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import FlowSection from '../../../components/root/shared/FlowSection.tsx';
import {
  MANAGER_STEP3_LOADING_TEXT,
  MANAGER_STEP3_TEXT,
} from '../../../manager/step3/constants.ts';
import { CLIENT_STEP2_TEXT } from '../constants.ts';
import type { TGeneratedDocumentSectionProps } from '../types.ts';

const GeneratedDocumentSection: React.FC<TGeneratedDocumentSectionProps> = ({
  isLoading,
  pdfUrl,
  isDisabled = false,
  onOpenPdf,
}) => (
  <FlowSection
    step={CLIENT_STEP2_TEXT.sectionStep}
    title={CLIENT_STEP2_TEXT.sectionTitle}
    description={CLIENT_STEP2_TEXT.sectionDescription}
    disabled={isDisabled}
  >
    <Box sx={guaranteesClientPageStyles.generatedDocumentPreview}>
      {isLoading ? (
        <Box sx={guaranteesClientPageStyles.flowLoadingState}>
          <CircularProgress size={24} />
          {MANAGER_STEP3_LOADING_TEXT}
        </Box>
      ) : (
        <Box
          component="iframe"
          src={pdfUrl || undefined}
          title={MANAGER_STEP3_TEXT.previewTitle}
          sx={guaranteesClientPageStyles.generatedDocumentIframe}
        />
      )}

      <Box sx={guaranteesClientPageStyles.generatedDocumentActions}>
        <Button
          variant="outlined"
          color="primary"
          type="button"
          sx={guaranteesClientPageStyles.generatedDocumentOpenButton}
          disabled={!pdfUrl}
          onClick={onOpenPdf}
        >
          {MANAGER_STEP3_TEXT.openButton}
        </Button>
      </Box>
    </Box>
  </FlowSection>
);

export default GeneratedDocumentSection;
